export default __webpack_public_path__ + "static/media/micronaut.88a498ea.svg";